import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { ContractsDirectKpiCfg, ContractsDirectKpiCfgService } from "./contractsDirectKpiCfg.service";
import { ContractsDirectKpiService, Range } from "./contractsDirectKpiService";
import { DateRange } from "./dateRange";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";

export class UnsignedContractsDirectServiceData {
    public consultant: number;
    public office: number;
    public updateTimestamp: Date;
}

export abstract class UnsignedContractsDirectService extends ContractsDirectKpiService<UnsignedContractsDirectServiceData> {
    protected abstract getRange(): DateRange;

    constructor(private serviceCfg: ContractsDirectKpiCfgService, private apigeeService: ApigeeService, private impersonationService: ImpersonationService,
        private officeSelectorService: OfficeSelectorService, private httpClient: HttpClient, injector: Injector) {
        super(injector);
    }

    protected getDates(): Range {
        return this.getDateRange(this.getRange());
    }

    protected async update(): Promise<UnsignedContractsDirectServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: UnsignedContractsDirectServiceData = null;
            try {
                let cfg: ContractsDirectKpiCfg = this.serviceCfg.getCfg();
                let { begin, end } = this.getDateRange(this.getRange());
                let url = cfg.unsignedContractsDirect.summaryEndpointPattern.format(this.officeSelectorService.selectedOffice.id, begin, end);
                result = await this.httpClient.post<UnsignedContractsDirectServiceData>(url, this.impersonationService.getNifImpersonate()).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}

@Injectable()
export class PastUnsignedContractsDirectService extends UnsignedContractsDirectService {
    public getClassName() { return "PastUnsignedContractsDirectService"; }

    constructor(serviceCfg: ContractsDirectKpiCfgService, apigeeService: ApigeeService, impersonationService: ImpersonationService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, impersonationService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.Past; }
}

@Injectable()
export class InmediateUnsignedContractsDirectService extends UnsignedContractsDirectService {
    public getClassName() { return "InmediateUnsignedContractsDirectService"; }

    constructor(serviceCfg: ContractsDirectKpiCfgService, apigeeService: ApigeeService, impersonationService: ImpersonationService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, impersonationService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.TodayTomorrow; }
}

@Injectable()
export class ForecastedUnsignedContractsDirectService extends UnsignedContractsDirectService {
    public getClassName() { return "ForecastedUnsignedContractsDirectService"; }

    constructor(serviceCfg: ContractsDirectKpiCfgService, apigeeService: ApigeeService, impersonationService: ImpersonationService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, impersonationService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.Forecast; }
}

@Injectable()
export class TodayTomorrowUnsignedContractsDirectService extends UnsignedContractsDirectService {
    public getClassName() { return "TodayTomorrowUnsignedContractsDirectService"; }

    constructor(serviceCfg: ContractsDirectKpiCfgService, apigeeService: ApigeeService, impersonationService: ImpersonationService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, impersonationService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.TodayTomorrow; }
}
